import {Entidade} from "./Entidade";
import {Column, Entity, PrimaryColumn} from "typeorm";

@Entity("unidademedida")
export class UnidadeMedida {
  @PrimaryColumn()
  id?: string
  @Column()
  nome?: string
  @Column()
  sigla?: string
  @Column()
  excluido?: boolean
}
